import { render, staticRenderFns } from "./TopNavNotificationBarSuccess.vue?vue&type=template&id=2b3dac78&"
import script from "./TopNavNotificationBarSuccess.vue?vue&type=script&lang=ts&"
export * from "./TopNavNotificationBarSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavNotificationBarSuccess.vue?vue&type=style&index=0&id=2b3dac78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports